// tslint:disable-next-line:typedef
export const Routes = {
    ROOT: "/",
    APPLICATION: "/application",
    HR: "/hr",
    LOGIN: "/login",
    GOOGLE_AUTH: "/auth",
    LOCAL_CREDENTIALS: "/local-credentials" // handover url for local testing
};
